import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConstantProvider} from './constants.service';


@Injectable({
  providedIn: 'root'
})
export class DataSegmentProvider {
  app: any;

  constructor(public http: HttpClient) {
    this.app = ConstantProvider;
  }

  /**
   * Function that makes a server call to retrieve data segment details
   *
   * @return
   */
  getDataSegment(coordinates) {
    const url: any = this.app.API_URL + '/api/data-segment?lat=' + coordinates.lat + '&lng=' + coordinates.lng;
    return this.http.get(url);
  }

  createDataSegment(data) {
    const url = this.app.API_URL + '/api/data-segment';
    const adminAuthToken = localStorage.getItem('admin_auth_token');
    const httpOptions = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: 'Bearer ' + adminAuthToken
      })
    };
    return this.http.post(url, data, httpOptions);
  }
}
